import React from 'react';
import {
  shape,
  func,
  string,
} from 'prop-types';
import { Button } from 'components/common';
import { onCtaClick } from 'money101/TWUtils';

import 'components/product/ProductPane/TabletCtaButtonRow.scss';

export const staticTextKeys = [
  'defaultCTALabel',
];

const TabletCtaButtonRow = ({
  ctaButton,
  onCtaLinkClick,
  staticText,
  name,
  showModal,
}) => {
  const openKGIModal = (el) => {
    if (name === '凱基銀行 個人信貸 超低利率專案') {
      showModal();
    } else {
      onCtaClick(ctaButton, onCtaLinkClick, el);
    }
  };

  return (
    <div className="tablet-cta-button-row">
      <Button
        primary
        className="tablet-cta-button"
        onClick={openKGIModal}
      >
        {ctaButton.label || staticText.defaultCTALabel}
      </Button>
    </div>
  );
};

TabletCtaButtonRow.propTypes = {
  ctaButton: shape({}),
  onCtaLinkClick: func,
  staticText: shape({}),
  name: string,
  showModal: func,
};

TabletCtaButtonRow.defaultProps = {
  ctaButton: {},
  onCtaLinkClick: undefined,
  staticText: {},
  name: '',
  showModal: undefined,
};

export default TabletCtaButtonRow;
